import { DomainCode } from "../../../models/common/model";
import { ContainerSizeType } from "../../../models/container_master_model/sizeType";
import { LocationModel } from "../../../models/container_master_model/location";

export enum RequestType {
  ONE_WAY = 'one_way',
  LEASE = 'lease',
  BUY_SELL = 'buy_sell',
}

export interface LeadRequestModel {
  id?: string;
  pol_list: string[];
  pod_list: string[];
  request_type: RequestType;
  transaction_type: string;
  container_size_type: string;
  condition: string;
  leasing_period: number;
  quantity: number;
  email: string;
  request_source: string;
  is_booking_closed?:boolean;
}

export interface LeadRequestError {
  pol_list: string[];
  pod_list: string[];
  request_type: string[];
  transaction_type: string[];
  container_size_type: string[];
  condition: string[];
  leasing_period: string[];
  quantity: string[];
  email: string[];
}

export class RequestModel {
  pol_list: LocationModel[];
  pod_list: LocationModel[];
  request_type: RequestType;
  transaction_type: string;
  container_size_type: ContainerSizeType;
  condition: DomainCode;
  leasing_period: number;
  quantity: number;
  email: string;
  request_source: string;
  is_booking_closed?:boolean;

  error: LeadRequestError;

  constructor() {
    this.pol_list = [];
    this.pod_list = [];
    this.request_type = null;
    this.transaction_type = null;
    this.container_size_type = null;
    this.condition = null;
    this.leasing_period = null;
    this.quantity = null;
    this.request_source = 'Customer Portal';

    this.resetErrors();
  }

  resetErrors() {
    this.error = {
      pol_list: [],
      pod_list: [],
      request_type: [],
      transaction_type: [],
      container_size_type: [],
      condition: [],
      leasing_period: [],
      quantity: [],
      email: [],
    }
  }

  is_valid() {
    this.resetErrors();

    if (this.request_type == null) {
      this.error.request_type.push('Please select a request type');
    }

    if (this.transaction_type == null && this.request_type != RequestType.LEASE) {
      this.error.transaction_type.push('Please select a transaction type');
    }

    if (this.container_size_type == null) {
      this.error.container_size_type.push('Please select a container size type');
    }

    if (this.condition == null) {
      this.error.condition.push('Please select a condition');
    }

    if (this.leasing_period == null && this.request_type == RequestType.LEASE) {
      this.error.leasing_period.push('Please select a leasing period');
    }

    if (this.quantity == null) {
      this.error.quantity.push('Please select a quantity');
    }

    if (this.email == null) {
      this.error.email.push('Please enter an email to continue');
    }


    return this.error.request_type.length == 0 &&
      this.error.transaction_type.length == 0 &&
      this.error.container_size_type.length == 0 &&
      this.error.condition.length == 0 &&
      this.error.leasing_period.length == 0 &&
      this.error.quantity.length == 0 &&
      this.error.email.length == 0
  }


  appendPol(port: LocationModel, index: number) {
    this.error.pol_list = [];

    this.pol_list[index] = port;
    this.pol_list = { ...this.pol_list };
  }

  appendPod(port: any, index: number) {
    this.error.pod_list = [];

    this.pod_list[index] = port;
    this.pod_list = { ...this.pod_list };
  }

  getLeadRequestData(): LeadRequestModel {
    return {
      request_type: this.request_type,
      transaction_type: this.transaction_type,
      container_size_type: this.container_size_type.id,
      condition: this.condition.id,
      leasing_period: this.leasing_period,
      quantity: this.quantity,
      pol_list: this.pol_list.map((item) => item.id),
      pod_list: this.pod_list.map((item) => item.id),
      email: this.email,
      request_source: this.request_source,
      is_booking_closed: this.is_booking_closed
    }
  }

  validate_port_lists() {
    this.error.pol_list = [];
    this.error.pod_list = [];

    if (this.pol_list.length < 1) {
      this.error.pol_list.push('Please select at least one Port');
    }

    if (this.request_type != RequestType.BUY_SELL) {
      //POD List
      if (this.pod_list.length < 1) {
        this.error.pod_list.push('Please select at least one Port');
      }
    }

    return this.error.pol_list.length == 0 && this.error.pod_list.length == 0;
  }

  getDetailUrl() {

    switch (this.request_type) {
      case RequestType.LEASE:
        return '/web-request/lead-request/lease-details';

      case RequestType.ONE_WAY:
        return '/web-request/lead-request/one-way-details'

      case RequestType.BUY_SELL:
        return '/web-request/lead-request/trading-details';

      default:
        return null;
    }

  }

}
